<template>
  <div>
    <p
      v-if="label"
      class="radio-label"
    >
      {{ label }}
    </p>
    <v-radio-group
      v-validate="{ required: required }"
      :value="value"
      :error-messages="errors.collect(name)"
      :data-vv-as="$t('label.question')"
      :data-vv-name="name"
      :required="required"
      :disabled="disabled"
      @change="updateValue"
    >
      <v-radio
        v-for="(val, index) in values"
        :key="index"
        off-icon=""
        on-icon=""
        :value="val?.[valueKey]"
        :label="val?.[labelKey]"
      />
    </v-radio-group>
  </div>
</template>
<script>
export default {
    name: 'BaseRadio',
    inject: ['$validator'],
    model: {
        prop: 'value',
        event: 'updateValue'
    },
    props: {
        value: {
            type: [String, Number],
            default: ''
        },
        name: {
            type: String,
            default: ''
        },
        required: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        values: {
            type: Array,
            default: () => []
        },
        labelKey: {
            type: String,
            default: 'label'
        },
        valueKey: {
            type: String,
            default: 'value'
        },
        label: {
            type: String,
            default: ''
        }
    },
    methods: {
        updateValue (value) {
            this.$emit('updateValue', value);
        }
    }
};
</script>
<style lang="scss">
.radio-label {
  font-size: 14px;
  color: #66686a;
}
</style>
